<template>
  <div>
    <div class="row">
      <template>
        <q-btn :label="labelField" icon-right="open_in_new" @click="openModal"/>
      </template>
      <q-btn
        v-if="value"
        label="Delete Credentials"
        icon-right="delete"
        color="negative"
        @click="deleteUser"
        class="q-ml-md"
      />
      <!-- <template v-else>
        <q-alert color="primary" type="warning">Please save this person before creating credentials.</q-alert>
      </template>-->
      <!-- <q-btn
          label="Reset Password"
          icon-right="lock_open"
          @click.native="resetPassword"
          v-if="value && value.email"
          :loading="resettingPassword"
      >
        <span slot="loading">
          <q-spinner class="on-left" />
          Resetting Password...
        </span>
      </q-btn>-->
    </div>
    <q-modal
      v-model="modal"
      :content-css="{minWidth: '50vw'}"
      :no-esc-dismiss="saving"
      :no-backdrop-dismiss="saving"
    >
      <div class="mdi-card full-width q-pa-md">
        <div>
          <div v-if="ready">
            <slot name="top"/>
            <!-- <div class="block q-pa-sm" v-if="!accountModal"></div> -->
            <div class="block full-width">
              <div class="row justify-between">
                <div class="col-md-10">
                  <h5 class="text-grey-6 uppercase no-margin q-headline q-pb-sm">User Info</h5>
                </div>
              </div>
            </div>
            <div class="mdi-card full-width q-pa-md">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <q-field
                    orientation="vertical"
                    label="Email / Username"
                    class="q-pa-md"
                    inset="full"
                    :icon="errors.has('Email', validatorFormName) ? 'star_border' : 'star'"
                    :icon-color="errors.has('Email', validatorFormName) ? 'negative' : 'blue-5'"
                    :class="{'is-required': errors.has('Email', validatorFormName)}"
                    :error="errors.has('Email', validatorFormName)"
                    :error-label="errors.first('Email', validatorFormName)"
                    :helper="'Username is: ' + oldUsername + ' - if this does not match the email.  It will after save.'"
                  >
                    <q-input
                      v-validate="'required|email|uniqueusername'"
                      data-vv-name="Email"
                      v-model="form.email"
                      type="email"
                      name="email"
                      class="no-shadow"
                      hide-underline
                      inverted-light
                      :color="errors.has('Email') ? 'negative' : inputBgColor"
                      :validator-form-name="validatorFormName"
                      :data-vv-scope="validatorFormName"
                      :after="[
                        {
                          icon: 'search',
                          condition: canLookupUser,
                          handler: findUser
                        }
                      ]"
                    ></q-input>
                  </q-field>
                  <!-- <q-field
                        orientation="vertical"
                        label="Username"
                        class="q-pa-md"
                        inset="full"
                        :icon="errors.has('Username', validatorFormName) ? 'star_border' : 'star'"
                        :icon-color="errors.has('Username', validatorFormName) ? 'negative' : 'blue-5'"
                        :class="{'is-required': errors.has('Username', validatorFormName)}"
                        :error="errors.has('Username', validatorFormName)"
                        :error-label="errors.first('Username', validatorFormName)"
                        :helper="errors.first('Username', validatorFormName)"
                      >
                      <q-input
                      v-validate="'required'"
                      data-vv-name="Username"
                      v-model="form.userName"
                      type="text"
                      name="userName"
                      class="no-shadow"
                      hide-underline
                      inverted-light
                      :color="errors.has('Username', validatorFormName) ? 'negative' : inputBgColor"
                      :validator-form-name="validatorFormName"
                      :data-vv-scope="validatorFormName"
                      />
                  </q-field>-->
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <q-field
                    orientation="vertical"
                    label="Role"
                    class="q-pa-md"
                    inset="full"
                    :icon="errors.has('Role', validatorFormName) ? 'star_border' : 'star'"
                    :icon-color="errors.has('Role', validatorFormName) ? 'negative' : 'blue-5'"
                    :class="{'is-required': errors.has('Role', validatorFormName)}"
                    :error="errors.has('Role', validatorFormName)"
                    :error-label="errors.first('Role', validatorFormName)"
                  >
                    <q-select
                      v-validate="'required'"
                      data-vv-name="Role"
                      v-model="form.roleId"
                      name="roleId"
                      class="no-shadow"
                      hide-underline
                      inverted-light
                      :options="roleSelections"
                      :color="errors.has('Role') ? 'negative' : inputBgColor"
                      :validator-form-name="validatorFormName"
                      :data-vv-scope="validatorFormName"
                    />
                  </q-field>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <q-field
                    orientation="vertical"
                    label="Password"
                    class="q-pa-md"
                    inset="full"
                    icon="edit"
                    :icon-color="errors.has('Password', validatorFormName) ? 'negative' : inputBgColor"
                    :class="{'is-required': errors.has('Password', validatorFormName)}"
                    :error="errors.has('Username', validatorFormName)"
                    :error-label="errors.first('Password', validatorFormName)"
                    :helper="errors.first('Password', validatorFormName)"
                  >
                    <q-input
                      v-validate="'min:6'"
                      data-vv-name="Password"
                      v-model="form.password"
                      type="password"
                      name="password"
                      class="no-shadow"
                      hide-underline
                      inverted-light
                      :color="errors.has('Password', validatorFormName) ? 'negative' : inputBgColor"
                      :validator-form-name="validatorFormName"
                      :data-vv-scope="validatorFormName"
                      ref="password"
                    />
                  </q-field>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <q-field
                    orientation="vertical"
                    label="Password Confirmation"
                    class="q-pa-md"
                    inset="full"
                    icon="edit"
                    :icon-color="errors.has('Password Confirmation', validatorFormName) ? 'negative' : inputBgColor"
                    :class="{'is-required': errors.has('Password Confirmation', validatorFormName)}"
                    :error="errors.has('Password Confirmation', validatorFormName)"
                    :error-label="errors.first('Password Confirmation', validatorFormName)"
                  >
                    <q-input
                      v-validate="form.password ? 'required|confirmed:password' : ''"
                      data-vv-name="Password Confirmation"
                      v-model="passwordConfirmation"
                      type="password"
                      name="passwordConfirmation"
                      class="no-shadow"
                      hide-underline
                      inverted-light
                      :color="errors.has('Password Confirmation') ? 'negative' : inputBgColor"
                      :validator-form-name="validatorFormName"
                      :data-vv-scope="validatorFormName"
                      data-vv-as="password"
                    />
                  </q-field>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <q-field
                    orientation="vertical"
                    label="Lock User Out / Prevent Login"
                    class="q-pa-md"
                    inset="full"
                    icon="edit"
                    :icon-color="inputBgColor"
                  >
                    <q-checkbox v-model="lockout" name="Lockout"/>
                  </q-field>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <q-field
                    orientation="vertical"
                    label="Failed Logins"
                    class="q-pa-md"
                    inset="full"
                  >{{ form.accessFailedCount }}
                  </q-field>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <q-field
                    orientation="vertical"
                    label="Last Logged In"
                    class="q-pa-md"
                    inset="full"
                  >{{ form.lastLoginDate }}
                  </q-field>
                </div>
              </div>
            </div>
            <div v-if="editingDisabled">
              <q-alert
                v-if="editingDisabled"
                type="warning"
                icon="warning"
                class="q-mb-md"
              >This record has been deleted / archived. You may not make edits to this record until it has been restore.
              </q-alert>
              <q-btn
                color="negative"
                @click="apiRestoreRecord"
                class="full-width"
                push
                size="lg"
                :disabled="false"
              >Restore
              </q-btn>
            </div>
            <div v-else>
              <q-btn
                color="primary"
                @click="submit"
                class="full-width"
                push
                size="lg"
                :disabled="false"
              >Save
              </q-btn>
            </div>
            <div name="goback">
              <q-btn @click="modal = false" color="negative" full class="q-mt-lg">Cancel / Close</q-btn>
            </div>
          </div>
          <q-inner-loading v-if="loading"></q-inner-loading>
        </div>
      </div>
    </q-modal>
  </div>
</template>
<script>
import colors from '../mixins/colors'
// import { debounce } from 'quasar'
// import { throttle } from 'quasar'

export default {
  mixins: [colors],
  name: 'CredentialsModal',
  props: {
    value: {
      type: Object,
      default: () => {
      }
    },
    column: {
      type: Object,
      required: true
    },
    _options: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      ready: false,
      loading: true,
      editingDisabled: false,
      validatorFormName: 'users',
      // inputBgColor: 'blue-grey-1',
      errorBg: 'negative',
      passwordConfirmation: null,
      lockout: false,
      roles: null,
      oldUsername: null,
      saving: false,
      modal: false,
      setUserChecks: 0,
      userSet: false,
      form: {
        accessFailedCount: 0,
        email: null,
        id: 0,
        lastLoginDate: null,
        lockoutEnabled: false,
        lockoutEnd: null,
        password: null,
        passwordNew: false,
        phoneNumber: null,
        roleId: null,
        userName: null
      },
      potentialUser: null
    }
  },
  computed: {
    roleSelections () {
      if (this.roles && this.roles.length > 0) {
        return this.roles.map(value => {
          let i = {}
          if (value.name) {
            i.label = value.name
          }
          if (value.id) {
            i.value = value.id
          }
          return i
        })
      } else {
        return [{value: 1, label: 'Admin'}, {value: 2, label: 'Customer'}, {value: 3, label: 'Super Admin'}]
      }
    },
    labelField () {
      return this.value ? 'Edit Credentials' : 'Create Credentials'
    },
    resource () {
      return this.column.relation && this.column.relation !== 'self' ? this.column.relation.namespace : null
    },
    parentId () {
      return this.$route.params ? this.$route.params.id : false
    },
    canLookupUser () {
      if (typeof this.potentialUser === 'number') {
        return true
      }
      return false
    }
  },
  filters: {
    formatLabel (label) {
      var date = new Date(label)
      if (date) {
        return date.toLocaleDateString('en-US')
      } else {
        return label
      }
    }
  },
  methods: {
    openModal () {
      // this.form.userName = this.value ? this.value.userName : ''
      // this.form.email = this.value ? this.value.email : ''
      // if (this.value) {
      //   this.form = this.value
      // }
      if (this.value && this.value.id) {
        this.getUser()
      }
      this.modal = true
    },
    async isUnique (username) {
      if (this.userSet) {
        this.$set(this, 'userSet', false)
        return true
      }
      let url = '/api/aspnetuser/emailexists'
      if (this.value && this.value.id) {
        url = `/api/aspnetuser/emailexists/${this.value.id}`
      }
      const {data} = await this.$axios.get(url, {
        // id: this.modelId || undefined,
        params: {email: username}
      })
      if (data) {
        // this.debouncedFindUser(data)
        // this.throttleFindUser(data)
        if (typeof data === 'number') {
          this.$set(this, 'potentialUser', data)
        }
        return {
          valid: false,
          data: {
            message: ` Email / Username is already taken.`
          }
        }
      } else {
        this.$set(this, 'potentialUser', null)
      }
      return true
    },
    async findUser () {
      // test1@test.com
      if (this.potentialUser) {
        try {
          const {data} = await this.$axios.get('/api/aspnetuser/' + this.potentialUser)
          if (data && data.id) {
            console.log('found aspnetuser', data)
            this.findPerson(data)
            // this.debouncedFindPerson(data)
            // this.throttleFindPerson(data)
            // throttle(() => {
            //   this.findPerson(data)
            // }, 300)
          }
        } catch (e) {
        }
      } else {
        this.$q.notify({
          message: 'No user found for this email/username'
        })
      }
    },
    async findPerson (userData) {
      // test1@test.com
      const config = {
        params: {
          $filter: `aspnetuserId eq ${userData.id}`,
          limit: 100
        }
      }
      try {
        const { data } = await this.$axios.get('/api/odata/person/paginate', config)
        if (data && data.data && data.data[0]) {
          this.$q.notify({
            message: `The following person is already associated with this user: ${data.data[0].firstName} ${data.data[0].lastName}`
          })
        } else {
          try {
            await this.$q.dialog({
              title: 'Confirm',
              message: 'This user exists, but is not associated with a person.  Would you like to associate this person with the user found?',
              ok: 'Yes',
              cancel: 'No'
            })
            // OK
            this.$set(this, 'userSet', true)
            delete userData.roles
            this.$set(this, 'form', userData)
          } catch (e) {
            // Picked "Cancel" or dismissed
          }
        }
      } catch (e) {
      }
    },
    async getUser () {
      // console.log('aspnetuser value', this.value)
      if (this.value && this.value.id) {
        try {
          const {data} = await this.$axios.get('/api/aspnetuser/' + this.value.id)
          if (data) {
            // this.user = data
            this.form.accessFailedCount = data.accessFailedCount
            this.form.email = data.email
            this.form.id = data.id
            this.form.lastLoginDate = data.lastLoginDate
            this.form.lockoutEnabled = data.lockoutEnabled
            this.form.lockoutEnd = data.lockoutEnd
            this.form.phoneNumber = data.phoneNumber
            this.form.roleId = data.roleId
            this.form.userName = data.email
            this.oldUsername = data.userName
            if (data.roles) {
              this.roles = data.roles
            }
            if (this.form.lockoutEnabled && this.form.lockoutEnd) {
              this.lockout = true
            }
            this.ready = true
            this.loading = false
          } else {
            this.$q.notify({
              message: 'Error fetching user'
            })
            this.ready = true
            this.loading = false
          }
        } catch (e) {
          this.$q.notify({
            message: 'Error fetching user'
          })
          this.ready = true
          this.loading = false
        }
      } else {
        // New User!
        this.ready = true
        this.loading = false
      }
    },
    async deleteUser () {
      this.$q
        .dialog({
          title: 'Confirm Delete User Credentials',
          message: 'Are you sure you want to remove this user? This person will no longer be able to log in.',
          ok: {
            label: 'Delete',
            color: 'negative'
          },
          cancel: true
        })
        .then(() => {
          const data = this.$axios
            .put(`/api/person/${this.parentId}`, {aspnetuserId: null})
            .then(response => {
              if (data && this.value && this.value.id) {
                console.log('data 2', data)
                console.log('this.value.id', this.value.id)
                const deleted = this.$axios.delete(`/api/aspnetuser/${this.value.id}?harddelete=true`, {})
                if (deleted) {
                  this.$q.notify({
                    message: 'User Credentials have been deleted',
                    type: 'negative'
                  })
                  this.oldUsername = null
                  this.form = {
                    accessFailedCount: 0,
                    email: null,
                    id: 0,
                    lastLoginDate: null,
                    lockoutEnabled: false,
                    lockoutEnd: null,
                    password: null,
                    passwordNew: false,
                    phoneNumber: null,
                    roleId: null,
                    userName: null
                  }
                  this.$emit('manual-update', 'aspnetuserId', null)
                  this.$emit('manual-update', 'aspnetuser', null)
                }
              }
            })
            .catch(error => {
              console.log(error)
            })
        })
        .catch(() => {
        })
    },
    async submit () {
      // console.log('submit')
      // console.log(this.$validator)
      const result = await this.$validator.validate(this.validatorFormName + '.*')
      if (!result) {
        this.$q.notify({
          message: 'Please complete all required fields',
          type: 'negative'
        })
        return
      }
      if (this.form.password && this.passwordConfirmation && this.form.password === this.passwordConfirmation) {
        this.form.passwordNew = true
      }
      if (!this.form.id) {
        // POST
        try {
          const {data} = await this.$axios.post(`/api/aspnetuser/0`, this.form)
          if (data) {
            if (data.success) {
              if (data.user) {
                this.$emit('manual-update', 'aspnetuserId', data.user.id)
                this.$emit('manual-update', 'aspnetuser', data.user)
                this.$set(this, 'modal', false)
              }
              this.$q.notify({
                message: 'User created',
                type: 'positive'
              })
            } else {
              this.$q.notify({
                message: 'Error creating user: ' + data.message
              })
            }
          } else {
            this.$q.notify({
              message: 'Error creating user'
            })
          }
        } catch (e) {
          this.$q.notify({
            message: 'Error creating user'
          })
        }
      } else {
        // PUT
        try {
          const {data} = await this.$axios.post(`/api/aspnetuser/${this.form.id}`, this.form)
          if (data) {
            // this.$set(this.timecardDays, day, extend(true, {}, data))
            // console.log('PUT Addition Saved: ', data)
            if (data.success) {
              if (data.user) {
                this.$emit('manual-update', 'aspnetuserId', data.user.id)
                this.$emit('manual-update', 'aspnetuser', data.user)
                this.$set(this, 'modal', false)
              }
              this.$q.notify({
                message: 'User saved',
                type: 'positive'
              })
            } else {
              this.$q.notify({
                message: 'Error saving user: ' + data.message
              })
            }
          } else {
            this.$q.notify({
              message: 'Error saving user'
            })
          }
        } catch (e) {
          this.$q.notify({
            message: 'Error saving user'
          })
        }
      }
    },
    async handleDeleteRecord () {
      let r = confirm('Are you sure you wish to delete this user?')
      if (r) {
        if (this.form.id) {
          try {
            const {data} = await this.$axios.delete(`/api/aspnetuser/${this.form.id}`)
            if (data && !data.error) {
              this.$q.notify({
                message: 'User deleted',
                type: 'positive'
              })
            } else {
              this.$q.notify({
                message: 'Error deleting user'
              })
            }
          } catch (e) {
            this.$q.notify({
              message: 'Error deleting user'
            })
          }
        } else {
          this.$q.notify({
            message: 'User does not exist or has not been created'
          })
        }
      }
    }
  },
  async created () {
    await this.getUser()
    this.$validator.extend('uniqueusername', {
      validate: this.isUnique,
      // validate: this.throttleIsUnique,
      getMessage: (field, params, data) => data.message
    })
  },
  // mounted () {
  //   this.debounceIsUnique = debounce(async (username) => {
  //     // console.log('debouncedFindUser', data)
  //     this.isUnique(username)
  //   }, 1000)
  //   this.debouncedFindUser = debounce(async (data) => {
  //     // console.log('debouncedFindUser', data)
  //     this.findUser(data)
  //   }, 1000)
  //   this.debouncedFindPerson = debounce(async (data) => {
  //     // console.log('debouncedFindPerson', data)
  //     this.findPerson(data)
  //   }, 1000)
  //   this.throttleIsUnique = debounce(async (username) => {
  //     // console.log('debouncedFindUser', data)
  //     this.isUnique(username)
  //   }, 1000)
  //   this.throttleFindUser = throttle(async (data) => {
  //     // console.log('debouncedFindUser', data)
  //     this.findUser(data)
  //   }, 2000)
  //   this.throttleFindPerson = throttle(async (data) => {
  //     // console.log('debouncedFindPerson', data)
  //     this.findPerson(data)
  //   }, 3000)
  // },
  watch: {
    lockout (val) {
      if (val) {
        this.form.lockoutEnabled = true
        this.form.lockoutEnd = '0100-01-01T00:00:00'
      } else {
        this.form.lockoutEnabled = false
        this.form.lockoutEnd = null
      }
    },
    'form.email' (val) {
      if (val) {
        this.form.userName = this.form.email
      }
    }
  }
}
</script>
